import { ISystemUser, TEAMS } from "@dl/declarations";
import * as yup from "yup";

export type UserFormData = Pick<
  ISystemUser,
  | "first_name"
  | "last_name"
  | "email"
  | "education"
  | "social_links"
  | "title"
  | "long_bio"
  | "short_bio"
  | "team"
  | "image"
  | "custom_role"
  | "is_active"
> & {
  _id?: string;
  collections: string[];
};

export type GuestUserFormData = Pick<
  ISystemUser,
  "first_name" | "last_name"
> & {
  _id?: string;
};

export const userInitialValues: UserFormData = {
  first_name: "",
  last_name: "",
  email: "",
  team: TEAMS.NEWSROOM.SLUG,
  education: [],
  social_links: {
    facebook: "",
    linkedin: "",
    rss: "",
    twitter: "",
    telegram: "",
    reddit: "",
  },
  title: "",
  long_bio: "",
  short_bio: "",
  image: "",
  custom_role: "",
  is_active: true,
  collections: [],
};

export const guestInitialValues: GuestUserFormData = {
  first_name: "",
  last_name: "",
};

const commonSchema = yup.object().shape({
  first_name: yup.string().required().label("First Name"),
  last_name: yup.string().required().label("Last Name"),
});

export const userSchema = commonSchema.shape({
  image: yup.string().required().label("Image"),
  email: yup.string().email().required().label("Email"),
  // education: yup.array().of(yup.string()).label("Education"),
  social_links: yup
    .object()
    .shape({
      facebook: yup.string().url().label("Facebook URL"),
      linkedin: yup.string().url().label("LinkedIn URL"),
      rss: yup.string().url().label("RSS URL"),
      twitter: yup.string().url().label("Twitter URL"),
      telegram: yup.string().url().label("Telegram URL"),
      reddit: yup.string().url().label("Reddit URL"),
    })
    .label("Social Links"),
  title: yup.string().required().label("User's Role"),
  team: yup.string().required().label("Team"),
  long_bio: yup.string().required().label("Bio"),
  // short_bio: yup.string().label("Short Bio"),
  custom_role: yup.string().required().label("Role"),
  is_active: yup.boolean().required().label("Active"),

  collections: yup.array().of(yup.string()).optional().label("Collections"),
});

export const guestSchema = commonSchema;
